"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFieldWithInput = exports.createFactoryUtils = exports.makeBreakpointSettings = exports.BREAKPOINT_KEYS = exports.DEFAULT_BREAKPOINTS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var type_guard_1 = require("@webnuts/type-guard");
// eslint-disable-next-line no-restricted-imports
var styled_components_1 = require("styled-components");
var css_types_1 = require("./css-types");
var position_1 = require("./css-types/position");
var text_decoration_1 = require("./css-types/text-decoration");
// https://getbootstrap.com/docs/4.5/layout/grid/#grid-options
exports.DEFAULT_BREAKPOINTS = {
    xlarge: 1200,
    large: 800,
    medium: 425,
    small: 0
};
exports.BREAKPOINT_KEYS = Object.keys(exports.DEFAULT_BREAKPOINTS);
/**
 * Generates breakpoint settings based on some settings.
 *
 * Use this to easily generate settings for the `utils.css.breakpoints` function.
 */
var makeBreakpointSettings = function (settings) {
    var optionalSettingsProps = Object.fromEntries(Object.entries(settings).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], settingGuard = _b[1];
        return [key, type_guard_1.optional(settingGuard)];
    }));
    var optionalSettings = type_guard_1.optional(type_guard_1.props(optionalSettingsProps));
    return type_guard_1.optional(type_guard_1.props({
        // NOTE: The keys in the return prop must be from `BREAKPOINTS_KEYS` due to performance.
        small: optionalSettings,
        medium: optionalSettings,
        large: optionalSettings,
        xlarge: optionalSettings
    }));
};
exports.makeBreakpointSettings = makeBreakpointSettings;
var isBreakpointKey = function (value) {
    return type_guard_1.is(type_guard_1.enums(exports.BREAKPOINT_KEYS))(value);
};
// Skip assertions in production, to avoid hogging the CPU during re-rendering.
var assertFunc = process.env.NODE_ENV === 'production' ? type_guard_1.fakeAssertFunction : type_guard_1.assertFunction;
var createFactoryUtils = function (breakpoints) {
    if (breakpoints === void 0) { breakpoints = exports.DEFAULT_BREAKPOINTS; }
    var upperMax = function (breakpoint) {
        var breakpointValue = breakpoints[breakpoint];
        var foundUpper = Object.values(breakpoints).reduce(function (previous, current) {
            if (previous === undefined) {
                return current > breakpointValue ? current : undefined;
            }
            else if (current < previous && current > breakpointValue) {
                return current;
            }
            return previous;
        }, undefined);
        // https://github.com/twbs/bootstrap/blob/7058f8928641c847b6afb3a8ef2022ce75a5ded8/scss/mixins/_breakpoints.scss#L34-L39
        return foundUpper === undefined ? undefined : foundUpper - 0.02;
    };
    var utils = {
        media: {
            between: function (options, styles) {
                return function () {
                    var _a = __assign({ mediaType: 'all', unit: 'px' }, options), min = _a.min, max = _a.max, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                    var minBreakpoint = typeof min === 'number' ? min : breakpoints[min];
                    var maxBreakpoint = typeof max === 'string' ? upperMax(max) : max;
                    var rules = __spreadArray(__spreadArray(__spreadArray([
                        mediaType
                    ], __read((minBreakpoint === 0 ? [] : ["(min-width: " + minBreakpoint + unit + ")"]))), __read((maxBreakpoint === undefined ? [] : ["(max-width: " + maxBreakpoint + unit + ")"]))), __read((orientation === undefined ? [] : ["(orientation: " + orientation + ")"])));
                    if (rules.length === 1 && rules[0] === 'all') {
                        return styles;
                    }
                    var query = rules.filter(function (rule) { return rule !== 'all'; }).join(' and ');
                    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            @media ", " {\n              ", "\n            }\n          "], ["\n            @media ", " {\n              ", "\n            }\n          "])), query, styles);
                };
            },
            max: function (options, styles) {
                return function () {
                    var normalizedOptions = typeof options === 'string' || typeof options === 'number' ? { target: options } : options;
                    var _a = __assign({ mediaType: 'all', unit: 'px' }, normalizedOptions), target = _a.target, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                    if (target === undefined) {
                        return styles;
                    }
                    var breakpoint = typeof target === 'string' ? upperMax(target) : target;
                    var rules = __spreadArray(__spreadArray([
                        mediaType
                    ], __read((breakpoint === undefined ? [] : ["(max-width: " + breakpoint + unit + ")"]))), __read((orientation === undefined ? [] : ["(orientation: " + orientation + ")"])));
                    if (rules.length === 1 && rules[0] === 'all') {
                        return styles;
                    }
                    var query = rules.join(' and ');
                    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            @media ", " {\n              ", "\n            }\n          "], ["\n            @media ", " {\n              ", "\n            }\n          "])), query, styles);
                };
            },
            min: function (options, styles) {
                return function () {
                    var normalizedOptions = typeof options === 'string' || typeof options === 'number' ? { target: options } : options;
                    var _a = __assign({ mediaType: 'all', unit: 'px' }, normalizedOptions), target = _a.target, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                    var breakpoint = typeof target === 'string' ? breakpoints[target] : target;
                    var rules = __spreadArray(__spreadArray([
                        mediaType
                    ], __read((breakpoint === 0 ? [] : ["(min-width: " + breakpoint + unit + ")"]))), __read((orientation === undefined ? [] : ["(orientation: " + orientation + ")"])));
                    if (rules.length === 1 && rules[0] === 'all') {
                        return styles;
                    }
                    var query = rules.join(' and ');
                    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            @media ", " {\n              ", "\n            }\n          "], ["\n            @media ", " {\n              ", "\n            }\n          "])), query, styles);
                };
            },
            only: function (options, styles) {
                return function () {
                    var normalizedOptions = typeof options === 'string'
                        ? isBreakpointKey(options)
                            ? { target: options }
                            : { mediaType: options }
                        : options;
                    var _a = __assign({ mediaType: 'all', unit: 'px' }, normalizedOptions), target = _a.target, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                    if (target === undefined) {
                        var rules = __spreadArray([mediaType], __read((orientation === undefined ? [] : ["(orientation: " + orientation + ")"])));
                        if (rules.length === 1 && rules[0] === 'all') {
                            return styles;
                        }
                        var query = rules.join(' and ');
                        return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n              @media ", " {\n                ", "\n              }\n            "], ["\n              @media ", " {\n                ", "\n              }\n            "])), query, styles);
                    }
                    return utils.media.between({ min: target, max: target, orientation: orientation, mediaType: mediaType, unit: unit }, styles)();
                };
            }
        },
        css: {
            rule: assertFunc([type_guard_1.string(), type_guard_1.optional(type_guard_1.union([type_guard_1.string(), type_guard_1.number()])), type_guard_1.optional(type_guard_1.union([type_guard_1.string(), type_guard_1.number()]))], function (property, value, fallback) {
                if (fallback === void 0) { fallback = undefined; }
                return function () {
                    var _a;
                    var normalizedValue = value !== null && value !== void 0 ? value : fallback;
                    var stringifiedValue = typeof normalizedValue === 'string' ? normalizedValue : normalizedValue === null || normalizedValue === void 0 ? void 0 : normalizedValue.toString();
                    return stringifiedValue === undefined ? '' : styled_components_1.css((_a = {}, _a[property] = stringifiedValue, _a));
                };
            }, { name: 'rule' }),
            tenary: assertFunc([type_guard_1.string(), type_guard_1.optional(type_guard_1.boolean()), type_guard_1.optional(type_guard_1.union([type_guard_1.string(), type_guard_1.number()])), type_guard_1.optional(type_guard_1.union([type_guard_1.string(), type_guard_1.number()]))], function (property, condition, trueValue, falseValue) {
                return function () {
                    return condition === true ? utils.css.rule(property, trueValue)() : utils.css.rule(property, falseValue)();
                };
            }, { name: 'tenary' }),
            breakpoint: assertFunc([type_guard_1.optional(type_guard_1.record(type_guard_1.enums(exports.BREAKPOINT_KEYS), type_guard_1.optional(type_guard_1.unknown()))), type_guard_1.unknown(), type_guard_1.func()], function (breakpoints, defaultSettings, mapper) {
                return function () {
                    var defaultSettingsCss = defaultSettings === undefined ? [] : [mapper(defaultSettings)];
                    var breakpointsCss = breakpoints === undefined
                        ? []
                        : Object.entries(breakpoints).reduce(function (acc, _a) {
                            var _b = __read(_a, 2), breakpoint = _b[0], breakpointSettings = _b[1];
                            return breakpointSettings === undefined
                                ? acc
                                : __spreadArray(__spreadArray([], __read(acc)), [
                                    utils.media.only({ target: breakpoint }, mapper(breakpointSettings))()
                                ]);
                        }, []);
                    var styles = __spreadArray(__spreadArray([], __read(defaultSettingsCss)), __read(breakpointsCss));
                    if (styles.length === 0) {
                        return '';
                    }
                    return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), styles);
                };
            }, { name: 'breakpoint' }),
            background: assertFunc([type_guard_1.optional(css_types_1.background)], function (background) { return function () {
                // Handle the empty case.
                if (background === undefined) {
                    return '';
                }
                if (type_guard_1.is(type_guard_1.prop('color', type_guard_1.optional(type_guard_1.string())))(background)) {
                    return utils.css.rule('background-color', background.color)();
                }
                else {
                    // We have one or more background functions on our hands.
                    var backgrounds = type_guard_1.is(type_guard_1.items(type_guard_1.unknown()))(background) ? background : [background];
                    if (backgrounds.length === 0) {
                        return '';
                    }
                    var backgroundFuncs = backgrounds.map(function (bg) { return bg.function + "(" + bg.args + ")"; }).join(',');
                    return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n              background: ", ";\n            "], ["\n              background: ", ";\n            "])), backgroundFuncs);
                }
            }; }, { name: 'background' }),
            font: assertFunc([type_guard_1.optional(css_types_1.font)], function (font) { return function () {
                if (font === undefined) {
                    return '';
                }
                return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            ", ";\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", ";\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.rule('font-size', font.size)(), utils.css.rule('font-family', font.family)(), utils.css.rule('font-style', font.style)(), utils.css.rule('font-weight', font.weight)(), utils.css.rule('letter-spacing', font.letterSpacing)(), utils.css.rule('line-height', font.lineHeight)(), utils.css.rule('text-transform', font.transform)(), utils.css.rule('text-align', font.align)(), utils.css.textDecoration(font.decoration)(), utils.css.rule('color', font.color)(), utils.css.rule('white-space', font.whiteSpace)(), utils.css.rule('word-break', font.wordBreak)(), utils.css.rule('overflow', font.overflow)(), utils.css.rule('text-overflow', font.textOverflow)());
            }; }, { name: 'font' }),
            border: assertFunc([type_guard_1.optional(css_types_1.border)], function (border) { return function () {
                if (border === undefined) {
                    return '';
                }
                var color = border.color, width = border.width, styleOption = border.style, radiusOption = border.radius;
                var _a = typeof styleOption === 'string'
                    ? { top: styleOption, left: styleOption, bottom: styleOption, right: styleOption }
                    : __assign({}, styleOption), top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                var _b = typeof radiusOption === 'string'
                    ? { topRight: radiusOption, topLeft: radiusOption, bottomRight: radiusOption, bottomLeft: radiusOption }
                    : __assign({}, radiusOption), topRight = _b.topRight, topLeft = _b.topLeft, bottomRight = _b.bottomRight, bottomLeft = _b.bottomLeft;
                return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.rule('border-color', color)(), utils.css.rule('border-width', width)(), utils.css.rule('border-top-style', top)(), utils.css.rule('border-left-style', left)(), utils.css.rule('border-bottom-style', bottom)(), utils.css.rule('border-right-style', right)(), utils.css.rule('border-top-right-radius', topRight)(), utils.css.rule('border-top-left-radius', topLeft)(), utils.css.rule('border-bottom-right-radius', bottomRight)(), utils.css.rule('border-bottom-left-radius', bottomLeft)());
            }; }, { name: 'border' }),
            padding: assertFunc([type_guard_1.optional(type_guard_1.union([css_types_1.padding, css_types_1.measureUnit]))], function (padding) { return function () {
                return padding === undefined
                    ? ''
                    : typeof padding === 'string'
                        ? styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                padding: ", ";\n              "], ["\n                padding: ", ";\n              "])), padding) : styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n                ", "\n                ", "\n                ", "\n                ", "\n              "], ["\n                ", "\n                ", "\n                ", "\n                ", "\n              "])), utils.css.rule('padding-top', padding.top)(), utils.css.rule('padding-left', padding.left)(), utils.css.rule('padding-bottom', padding.bottom)(), utils.css.rule('padding-right', padding.right)());
            }; }, { name: 'padding' }),
            margin: assertFunc([type_guard_1.optional(type_guard_1.union([css_types_1.padding, css_types_1.measureUnit]))], function (margin) { return function () {
                return margin === undefined
                    ? ''
                    : typeof margin === 'string'
                        ? styled_components_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n                margin: ", ";\n              "], ["\n                margin: ", ";\n              "])), margin) : styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n                ", "\n                ", "\n                ", "\n                ", "\n              "], ["\n                ", "\n                ", "\n                ", "\n                ", "\n              "])), utils.css.rule('margin-top', margin.top)(), utils.css.rule('margin-left', margin.left)(), utils.css.rule('margin-bottom', margin.bottom)(), utils.css.rule('margin-right', margin.right)());
            }; }, { name: 'margin' }),
            /** @see <https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration> */
            textDecoration: assertFunc([type_guard_1.optional(text_decoration_1.textDecoration)], function (textDecoration) { return function () {
                if (textDecoration === undefined || typeof textDecoration === 'string') {
                    return utils.css.rule('text-decoration', textDecoration)();
                }
                return styled_components_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.rule('text-decoration-line', textDecoration.line === undefined || typeof textDecoration.line === 'string'
                    ? textDecoration.line
                    : textDecoration.line.join(' '))(), utils.css.rule('text-decoration-style', textDecoration.style)(), utils.css.rule('text-decoration-color', textDecoration.color)(), utils.css.rule('text-decoration-thickness', textDecoration.thickness)());
            }; }, { name: 'textDecoration' }),
            // TODO: Correctly handle multiple transitions on the same element.
            transition: assertFunc([type_guard_1.string(), type_guard_1.optional(css_types_1.transition)], function (rule, transition) { return function () {
                var _a, _b;
                return transition === undefined
                    ? ''
                    : styled_components_1.css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n                transition: ", " ", " ", " ", ";\n              "], ["\n                transition: ", " ", " ", " ", ";\n              "])), rule, transition.duration, (_a = transition.function) !== null && _a !== void 0 ? _a : '', (_b = transition.delay) !== null && _b !== void 0 ? _b : '');
            }; }, { name: 'transition' }),
            position: assertFunc([type_guard_1.optional(position_1.position)], function (position) { return function () {
                if (position === undefined) {
                    return '';
                }
                if (typeof position === 'string') {
                    return utils.css.rule('position', position)();
                }
                return styled_components_1.css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.rule('position', position.position)(), utils.css.rule('top', position.top)(), utils.css.rule('left', position.left)(), utils.css.rule('right', position.right)(), utils.css.rule('bottom', position.bottom)());
            }; }, { name: 'position' }),
            boxShadow: assertFunc([type_guard_1.optional(css_types_1.boxShadow)], function (shadow) { return function () {
                if (shadow === undefined) {
                    return '';
                }
                if (typeof shadow === 'string') {
                    return utils.css.rule('box-shadow', shadow)();
                }
                var inset = shadow.inset, x = shadow.x, y = shadow.y, blur = shadow.blur, spread = shadow.spread, color = shadow.color;
                return utils.css.rule('box-shadow', (inset === true ? 'inset' : '') + " " + x + " " + y + " " + blur + " " + spread + " " + color)();
            }; }, { name: 'shadow' }),
            orientation: assertFunc([type_guard_1.optional(css_types_1.orientation)], function (orientation) {
                return function () {
                    if (orientation === undefined) {
                        return '';
                    }
                    var maps = {
                        top: 'flex-start',
                        left: 'flex-start',
                        middle: 'center',
                        center: 'center',
                        bottom: 'flex-end',
                        right: 'flex-end'
                    };
                    var justifyContent = orientation.horizontal === undefined ? undefined : maps[orientation.horizontal];
                    var alignItems = orientation.vertical === undefined ? undefined : maps[orientation.vertical];
                    return styled_components_1.css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n            "])), utils.css.rule('justify-content', justifyContent)(), utils.css.rule('align-items', alignItems)());
                };
            }, { name: 'orientation' }),
            height: assertFunc([type_guard_1.optional(css_types_1.height)], function (height) {
                return function () {
                    if (height === undefined) {
                        return '';
                    }
                    var _a = typeof height === 'string'
                        ? { _default: height, maxHeight: undefined, minHeight: undefined }
                        : { _default: height.default, maxHeight: height.max, minHeight: height.min }, _default = _a._default, maxHeight = _a.maxHeight, minHeight = _a.minHeight;
                    return styled_components_1.css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n            "])), utils.css.rule('height', _default, '100%'), utils.css.rule('max-height', maxHeight), utils.css.rule('min-height', minHeight));
                };
            }, { name: 'height' }),
            width: assertFunc([type_guard_1.optional(css_types_1.width)], function (width) {
                return function () {
                    if (width === undefined) {
                        return '';
                    }
                    var _a = typeof width === 'string'
                        ? { maxWidth: undefined, _default: width, minWidth: undefined }
                        : { maxWidth: width.max, _default: width.default, minWidth: width.min }, maxWidth = _a.maxWidth, _default = _a._default, minWidth = _a.minWidth;
                    return styled_components_1.css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n            "])), utils.css.rule('width', _default), utils.css.rule('max-width', maxWidth), utils.css.rule('min-width', minWidth));
                };
            }, { name: 'width' })
        }
    };
    return utils;
};
exports.createFactoryUtils = createFactoryUtils;
/**
 * Stitches a given <Field> and input that takes Field renderProps together.
 *
 * Any rest props are put on the input
 */
var createFieldWithInput = function (displayName, Field, Input) {
    var FieldWithInput = react_1.forwardRef(function (_a, ref) {
        var label = _a.label, errorText = _a.errorText, name = _a.name, id = _a.id, invalid = _a.invalid, props = __rest(_a, ["label", "errorText", "name", "id", "invalid"]);
        return (jsx_runtime_1.jsx(Field, __assign({ label: label, errorText: errorText, name: name, id: id, invalid: invalid }, { children: function (fieldProps) { return jsx_runtime_1.jsx(Input, __assign({ ref: ref }, fieldProps, props), void 0); } }), void 0));
    });
    FieldWithInput.displayName = displayName;
    return FieldWithInput;
};
exports.createFieldWithInput = createFieldWithInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
